export const messageStyle = {
  borderRadius: '4px',
};

export const centerAlignmentStyle = {
  textAlign: 'center',
};

export const imageUrlInputStyle = {
  border: '1px solid lightgrey',
  borderRadius: '4px',
  width: '100%',
};

export const buttonContainerStyle = {
  display: 'flex',
  gap: '12px',
  marginTop: '-16px',
};

export const previewButtonContainerStyle = {
  display: 'flex',
  gap: '12px',
  marginTop: '24px',
};

export const hiddenInputStyle = {
  display: 'none',
};

export const imagePreviewStyle = (imageLoading) => ({
  display: imageLoading ? 'none' : 'block',
  height: 'auto',
  margin: '0 auto',
  maxHeight: '500px',
  maxWidth: '100%',
});

export const containerStyle = {
  backgroundColor: '#ffffff',
  border: '1px solid #e5e5e5',
  borderRadius: '8px',
  marginTop: '24px',
  padding: '24px',
};

export const headerStyle = {
  alignItems: 'baseline',
  backgroundColor: '#f5f5f5',
  borderBottom: '1px solid #e5e5e5',
  display: 'flex',
  gap: '12px',
  marginBottom: '12px',
  marginLeft: '-24px',
  marginRight: '-24px',
  marginTop: '-24px',
  paddingBottom: '12px',
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingTop: '16px',
};

export const titleStyle = {
  color: '#111111',
  fontSize: '16px',
  fontWeight: '600',
  margin: '0',
};

export const subtextStyle = {
  color: '#757575',
  fontSize: '13px',
  margin: '0',
};

export const textAreaStyle = {
  border: '1px solid #e5e5e5',
  borderRadius: '4px',
  fontFamily: 'inherit',
  fontSize: '14px',
  minHeight: '120px',
  padding: '12px',
  resize: 'vertical',
  width: '100%',
};

export const charCountStyle = {
  color: '#757575',
  fontSize: '12px',
  marginTop: '4px',
  textAlign: 'right',
};

export const imagePreviewContainerStyle = {
  alignItems: 'flex-start',
  display: 'flex',
  gap: '24px',
};

export const imagePreviewLeftStyle = {
  alignItems: 'center',
  backgroundColor: '#f5f5f5',
  borderRadius: '4px',
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
  minHeight: '332px',
  padding: '16px',
};

export const imagePreviewRightStyle = {
  flex: '1',
};

export const imagePreviewImageStyle = {
  borderRadius: '4px',
  height: 'auto',
  maxHeight: '300px',
  maxWidth: '100%',
};

export const inputLabelStyle = {
  color: '#111111',
  display: 'block',
  fontSize: '14px',
  fontWeight: '500',
  marginBottom: '8px',
  textAlign: 'left',
};

export const updateButtonContainerStyle = {
  marginBottom: '24px',
  marginTop: '-16px',
  textAlign: 'center',
};
